<template>
  <div class="mapRouter"
       style="height:100%;">
    <toolBar @succeeUpload="succeeUpload"
             @handleDeleteImg="handleDeleteImg"></toolBar>
    <div class="mainBox">
      <div class="left-container" v-show="leftShow">
        <img src="@/assets/image/zoom.png" v-show="leftShow && !rightShow" @click="doShrink">
        <img src="@/assets/image/zoom-open.png" v-show="leftShow && rightShow" @click="doEnlarge">
        <div id="canvasBox"></div>
      </div>
      <div class="right-container" v-show="rightShow">
        <PanoramicAlone ref="panoramicAlone" @panoramicAloneResize="panoramicResize" />
      </div>

      <mapRouteFormPanel v-if="['route'].includes(source)"></mapRouteFormPanel>
    </div>
  </div>
</template>
<script>
import { LayerManager, EventManager, fabric, eventHub } from '@aibee/vincent';
import { mapGetters } from 'vuex';
import layerManager from '@aibee/vincent/core/layerManager';
import toolBar from '@/components/mapComponents/toolBar.vue';
import { mapUpload, mapDelete, createPoi, updatePoi, deletePoi, queryAllPois, queryAllIcon } from '@/api/map';
import mapRouteFormPanel from '@/components/mapComponents/mapRouteFormPanel.vue';
import PanoramicAlone from '@/components/mapComponents/panoramicAlone.vue';
import eventHubPro from '@/utils/eventHub';

const { eventStatus } = EventManager;

export default {
  name: 'mapRouter',
  components: { toolBar, mapRouteFormPanel, PanoramicAlone },
  computed: {
    ...mapGetters(['floorInfo']),
    source() {
      return this.$route.params.source;
    },
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
  },
  data() {
    return {
      layer: null,
      canvas: null,
      uploadImage: null,
      selectedIcon: null,
      selectedBlock: null,
      iconList: [],
      svgSize: null,
      leftShow: true,
      rightShow: false,
    };
  },
  mounted() {
    if (this.floorInfo) this.init();
  },
  destroyed() {
    if (layerManager.getLayer('图层1')) {
      layerManager.deleteLayer('图层1');
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.query.floor_id': function (val) {
      this.createImg(this.floorInfo[1].floor_cmap);
    },
    source() {
      if (this.canvas) {
        this.resetCanvas();
      }
    },
    floorInfo(newVal, oldVal) {
      if (newVal[1] && newVal[1].floor_cmap !== this.cmapUrl) this.init();
    },
  },
  methods: {
    init() {
      if (!['live', 'navigation'].includes(this.source)) {
        this.initCanvas();
        if (this.floorInfo.length > 0) {
          const url = this.floorInfo[1].floor_cmap;
          this.cmapUrl = url;
          this.initSvg(url);
        }
      }

      this.initEvent();
    },
    resetCanvas() {
      const url = this.floorInfo[1].floor_cmap;
      this.cmapUrl = url;
      this.canvas.clear();
      this.clearEvent();
      this.initSvg(url);
      this.initEvent();
    },
    initCanvas() {
      // 为了获取canvasBox的尺寸，也可以自定义设置
      const canvasBox = document.querySelector('#canvasBox');
      this.CANVAS_WIDTH = canvasBox.offsetWidth;
      this.CANVAS_HEIGHT = canvasBox.offsetHeight;
      LayerManager.init('#canvasBox', {
        isDrawingMode: false,
        width: this.CANVAS_WIDTH,
        height: this.CANVAS_HEIGHT,
      });
      this.layer = layerManager.getCurrentLayer();
      this.canvas = this.layer.getCanvas();
    },
    initSvg(mapUrl) {
      this.loadSvg(
        mapUrl,
        // callback
        (svgObj) => {
          this.$store.state.app.floorSvgSize = {
            width: svgObj.width,
            height: svgObj.height,
          };
          /* eslint-disable no-underscore-dangle */
          this.mapObjects = svgObj.getObjects();
          svgObj.set({
            originX: 'center',
            originY: 'center',
          }).setCoords();
          svgObj.activeSelect();
          // console.log(svgObj.getObjects().map(item => item.getSvgTransformMatrix()));
          this.layer.unGroup();
          this.layer.discardActiveObject();
          this.queryAllIcon(true);
          this.mapObjects.forEach((item) => {
            item.set({
              lockMovementX: true,
              lockMovementY: true,
              hasControls: false,
            }).setCoords();
            this.bindMapEvent(item);
          });
        },
      );
    },
    bindMapEvent(obj) {
      obj.on('selected', (options) => {
        this.$nextTick(() => {
          if (!options.target) return;
          // console.log(options.target);
          this.selectedBlock = options.target;
          const allPoiIcon = layerManager.getCurrentLayer().getAllObjects().filter(item => item.groupType === 'svgIcon');
          // eslint-disable-next-line eqeqeq
          const currentPoiItem = allPoiIcon.find(item => item.poiParams && item.poiParams.block_id == `${this.selectedBlock.id}`);
          this.selectedIcon = currentPoiItem || null;
        });
      });
      obj.on('deselected', (options) => {
        this.selectedBlock = null;
        this.selectedIcon = null;
      });
    },
    loadSvg(url, callback) {
      if (!url) this.$message.error('地图url为空');
      fabric.loadSVGFromURL(
        url,
        (objects, options) => {
          if (Array.isArray(objects)) {
            const obj = fabric.util.groupSVGElements(objects, options);
            this.canvas.add(obj);
            if (callback instanceof Function) callback(obj);
          } else {
            console.error('加载svg失败');
          }
        },
      );
    },
    initEvent() {
      if (['poiLabel'].includes(this.source)) {
        this.canvas.on('drop', this.onDrop);
        this.canvas.on('selection:created', this.onSelected);
        this.canvas.on('selection:updated', this.onSelected);
      }
    },
    clearEvent() {
      this.canvas.off('drop');
    },
    onSelected(e) {
      if (e.target && e.target.type === 'CirclePoint') {
        this.selectedBlock = e.target;
      }
    },
    onDrop(options) {
      const event = options.e;
      const pointer = this.canvas.getPointer(options.e);
      const config = JSON.parse(event.dataTransfer.getData('materailItem'));
      // config.url += '?x-oss-process=style/stylename';
      this.addSvgIcon({ config, icon_id: config.id, poi_name: config.description }, pointer, config.description, 'create', true);
    },
    addSvgIcon(poiParams, { x, y }, text, addMethod, canmove) {
      const { config } = poiParams;
      this.loadSvg(
        config.url,
        // callback
        (svgImg) => {
          svgImg.scale(0.5);
          svgImg.bringToFront();
          const svgObj = new fabric.Group([svgImg], {});
          if (text) {
            const { left, top, width, height } = svgObj.getBoundingRect(true);
            const iText = this.createText(text, { x: (left + width / 2), y: (top + height + 10) });
            svgObj.addWithUpdate(iText);
          }
          let svgSetting = {
            lockMovementX: true,
            lockMovementY: true,
            lockRotation: true,
            hasControls: false,
          };
          if (poiParams.shape_params) {
            svgSetting = poiParams.shape_params;
          } else if (canmove) {
            Object.assign(svgSetting, { lockMovementX: false, lockMovementY: false });
          }
          svgObj.set({
            ...svgSetting,
            left: x,
            top: y,
          }).setControlsVisibility({
            ml: false,
            mr: false,
            mt: false,
            mb: false,
            mtr: false,
          }).setCoords();
          this.bindSvgIconSelect(svgObj);
          svgObj.groupType = 'svgIcon';
          svgObj.poiParams = poiParams;
          if (addMethod === 'create') this.createAndUpdatePoi(svgObj, { ...poiParams, shape_params: svgSetting }, 'create');
          this.canvas.remove(svgImg);
          this.canvas.add(svgObj);
          this.canvas.renderAll();
        },
        () => {},
        { crossOrigin: 'Anonymous' },
      );
    },
    createText(text, { x, y }) {
      const IText = new fabric.IText(text, {
        left: x,
        top: y,
        fontSize: 12,
      });
      return IText;
    },
    bindSvgIconSelect(obj) {
      obj.on('selected', (options) => {
        this.$nextTick(() => {
          if (!options.target) return;
          const { groupType } = options.target;
          if (groupType === 'svgIcon') {
            this.selectedIcon = options.target;
          }
        });
      });
      obj.on('deselected', (options) => {
        this.selectedIcon = null;
      });
    },
    async succeeUpload(val) {
      if (!this.$route.query.floor_id) {
        this.$message.error('请选择楼层');
      }
      const params = {
        floor_id: this.$route.query.floor_id,
        map_type: this.$route.params.source,
        map_file: val.map_file,
        img_type: val.img_type,
      };
      const { data } = await mapUpload(params);
      this.uploadImage = data.map_url;
      this.createImg(this.uploadImage);
    },
    createImg(imgUrl) {
      const imgElement = document.createElement('img');
      imgElement.src = imgUrl;
      imgElement.onload = () => {
        const imgInstance = new fabric.Image(imgElement, {
          left: 0,
          top: 0,
          lockMovementX: true,
          lockMovementY: true,
          lockRotation: true,
          hasControls: false,
          opacity: 0.85,
          mapData: {

          },
        });
        this.canvas.add(imgInstance);
      };
    },
    handleDeleteImg() {
      mapDelete({ floor_id: 13, map_type: 'cmap' }).then(() => {
        this.canvas.clear();
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      });
    },
    createAndUpdatePoi(poiIcon, poiParams, type) {
      const poiParamsCopy = JSON.parse(JSON.stringify(poiParams));
      const iText = poiIcon.getObjects().find(item => item.type === 'i-text');
      const svgImage = poiIcon.getObjects().find(item => item.type === 'group');
      const { left: tLeft, top: tTop } = iText.getBoundingRect(true);
      const { left: iLeft, top: iTop } = svgImage.getBoundingRect(true);
      const centerPoint = poiIcon.getCenterPoint();
      const textCenterPoint = iText.getCenterPoint();
      const imageCenterPoint = svgImage.getCenterPoint();

      delete poiParamsCopy.config;
      if (!poiParamsCopy.business_hours) poiParamsCopy.business_hours = [];
      poiParamsCopy.business_hours = poiParamsCopy.business_hours.map(item => new Date(item).getTime());

      const data = {
        block_id: -1,
        place_id: this.placeId,
        floor_id: this.floorId,
        text_x: tLeft,
        text_y: tTop,
        image_x: iLeft,
        image_y: iTop,
        center_x: centerPoint.x,
        center_y: centerPoint.y,
        ...poiParamsCopy,
      };
      if (type === 'create') {
        createPoi({ data }).then((res) => {
          this.queryAllPois();
        }).catch((err) => {
          this.canvas.remove(poiIcon);
        });
      } else {
        updatePoi({
          data,
          params: {
            id: poiParamsCopy.id,
          },
        }).then((res) => {
          this.queryAllPois();
        });
      }
    },
    queryAllIcon(isLoadPois) {
      const params = {
        params: {
          place_id: this.placeId,
        },
      };
      queryAllIcon(params).then((res) => {
        this.iconList = res.data;
        if (isLoadPois) this.queryAllPois();
      });
    },
    deletePoi(id) {
      deletePoi({
        params: {
          id,
        },
      }).then(() => {
        this.queryAllPois();
      });
    },
    clearPois() {
      const allPoiIcon = layerManager.getCurrentLayer().getAllObjects().filter(item => item.groupType === 'svgIcon');
      allPoiIcon.forEach((item) => {
        this.layer.removeObject(item);
      });
    },
    queryAllPois() {
      queryAllPois({
        params: {
          place_id: this.placeId,
          floor_id: this.floorId,
        },
      }).then(({ data }) => {
        this.clearPois();
        data.forEach((item) => {
          item.config = JSON.parse(JSON.stringify(this.iconList.find(icon => icon.id === item.icon_id)));
          this.addSvgIcon({ ...item }, { x: item.center_x, y: item.center_y }, item.poi_name, 'update');
        });
      });
    },
    doEnlarge() {
      this.leftShow = true;
      this.rightShow = false;
    },
    doShrink() {
      this.leftShow = true;
      this.rightShow = true;

      this.$nextTick(() => {
        this.$refs.panoramicAlone.stage.forceResize();
        eventHub.$emit('debounceReloadPanoramic');
      });
    },
    panoramicResize(val) {
      if (val) {
        this.leftShow = true;
        this.rightShow = true;
      } else {
        this.leftShow = false;
        this.rightShow = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mapRouter {
  display: flex;
  flex-direction: column;
  .mainBox {
    flex: 1;
    display: flex;
    position: relative;
    background-color: #1b1b1b;

    .left-container {
      height: 100%;
      flex: 1;
      margin: 0 3px;
      position: relative;
      overflow: hidden;

      img{
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 9;
        opacity: 0.5;
        cursor: pointer;
      }
    }
    .right-container {
      height: 100%;
      flex: 1;
      margin: 0 3px;
      overflow: hidden;
    }
    #canvasBox {
      flex: 1;
      height: 100%;
      background-color: #fff;
      position: relative;
      ::v-deep >div{
        position: absolute!important;
        left: 0;
        top: 0;
      }
    }
    .mapLabelFormPanel{
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
    .routeLabelFormPanel {
      width: 280px;
    }
  }

}
</style>
